<template>
  <ContentContainer :loadingStatus="isLoading">
    <div>
    <div class="header">
      {{ $t('hotel') }}
    </div>
    <div class="page-content">
      <div class="hotel-list content-wrapper">
        <div class="page-header">{{ $t('hotelList') }}</div>
        <div>
          <el-row>
            <el-col :span="4">
              <el-input :placeholder="$t('keyword')"
                        @input="isTyping = true"
                        v-model="keyword"></el-input>
            </el-col>
            <el-col :span="20">
              <el-button type="primary"
                         icon="el-icon-plus"
                         style="float: right"
                         @click="onPopupAddHotelButtonClick">
                {{ $t('newHotel') }}
              </el-button>
            </el-col>
          </el-row>
            <div style="margin-top: 25px">
              <el-table
                id="hotel-list-table"
                :data="hotelListPerPage"
                style="width: 100%"
                :row-class-name="getRowClassName"
                header-row-class-name="table-header-color"
                v-loading="isTyping">
                <el-table-column
                  prop="name"
                  :label="$t('hotels')">
                </el-table-column>
                <el-table-column
                  :label="$t('code')">
                  <template slot-scope="scope">{{ getHotelCode(scope.row) }}</template>
                </el-table-column>
                <el-table-column
                  :label="$t('status')">
                  <template slot-scope="scope">
                    <el-tag
                      :type="scope.row.isEnable === 1 ? 'success' : 'danger'" size="mini"
                      disable-transitions>{{ getHotelStatus(scope.row.isEnable) }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('createdDate')">
                  <template slot-scope="scope">{{ dateFormat.long(new Date(scope.row.createdAt)) }}</template>
                </el-table-column>
                <el-table-column>
                  <template slot-scope="scope">
                    <el-button type="primary" size="small" icon="el-icon-edit" plain circle @click="onEditButtonClick(scope.row.id)"></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 10px">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="filterHotel().length"
                  :page-size="pageSize"
                  :pager-count="11"
                  :current-page="currentPage"
                  @current-change="changePage">
                </el-pagination>
              </div>
            </div>
        </div>
        <PopupAddHotel
          :visible="isPopupAddHotelVisible"
          @onClose="isPopupAddHotelVisible = false"
          @onAdded="onAddHotelSuccess">
        </PopupAddHotel>
      </div>
    </div>
  </div>
  </ContentContainer>
</template>

<script>
import i18nMessages from '@/translations/Hotel/List.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import HotelApi from '@/api/hotel-api'
import PopupAddHotel from './components/PopupAddHotel'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import { filterDataByKeyword, getDataOnPaging, adjustCurrentPage } from '@/services/general-service'
import { getStatusName } from '@/helpers'
import { STATUS, VUEX_EVENT } from '@/configs/constant'
import { mapState } from 'vuex'
import { get, debounce } from 'lodash'
import { dateFormat } from '@/helpers/datetime'

export default {
  name: 'HotelList',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { PopupAddHotel, ContentContainer },
  i18n: { messages: i18nMessages },
  created: async function () {
    this.selectedCompanyId = this.activeCompanyId
    this.getHotelList()
  },
  computed: {
    ...mapState({
      activeCompanyId: state => state.general.activeCompanyId
    })
  },
  watch: {
    activeCompanyId: async function (val) {
      this.selectedCompanyId = val
      await this.getHotelList()
    },
    keyword: debounce(function () {
      this.isTyping = false
    }, 300),
    isTyping: function (value) {
      if (!value) {
        this.searchHotel(this.keyword)
      }
    }
  },
  data () {
    return {
      dateFormat,
      isPopupAddHotelVisible: false,
      isLoading: false,
      selectedCompanyId: '',
      keyword: '',
      hotelList: [],
      currentPage: 1,
      pageSize: 10,
      hotel: {
        id: '',
        code: '',
        name: '',
        isEnable: STATUS.ENABLE
      },
      isTyping: false,
      filterHotelList: [],
      hotelListPerPage: []
    }
  },
  methods: {
    getHotelList: async function () {
      try {
        this.isLoading = true
        this.hotelList = await HotelApi.list()
        this.$store.dispatch(VUEX_EVENT.GENERAL.SET_HOTEL_LIST, this.hotelList)
      } catch (err) {
        this.alertError(err.message)
      }
      this.searchHotel()
      this.isLoading = false
    },
    searchHotel: function (keyWord = '') {
      const searchKeys = ['code', 'name']
      this.filterHotelList = filterDataByKeyword(this.hotelList, keyWord, searchKeys)
      this.makeHotelListPage()
    },
    makeHotelListPage: function () {
      const filteredHotelList = this.filterHotelList.sort((a, b) => {
        return (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 : 1
      })
      this.currentPage = adjustCurrentPage(filteredHotelList.length, this.currentPage, this.pageSize)
      this.hotelListPerPage = getDataOnPaging(filteredHotelList, this.currentPage, this.pageSize)
    },
    getHotelStatus: function (status) {
      return this.$t(getStatusName(status))
    },
    getHotelCode: function (hotel) {
      const hotelCode = get(hotel, 'code', '-')

      return hotelCode
    },
    changePage: function (page) {
      this.currentPage = page
      this.searchHotel()
    },
    filterHotel: function () {
      const searchKeys = ['code', 'name']
      const filteredHotelList = filterDataByKeyword(this.hotelList, this.keyword, searchKeys)

      return filteredHotelList
    },
    onPopupAddHotelButtonClick: function () {
      this.isPopupAddHotelVisible = true
    },
    onAddHotelSuccess: function (hotel) {
      this.hotelList.push(hotel)
      this.searchHotel()
      this.$store.dispatch(VUEX_EVENT.GENERAL.SET_HOTEL_LIST, this.hotelList)
    },
    onEditButtonClick: function (hotelId) {
      this.$store.dispatch(VUEX_EVENT.GENERAL.SET_ACTIVE_HOTEL_ID, hotelId)
      this.$router.push({
        name: 'HotelInfo'
      })
    },
    getRowClassName: function ({ row, rowIndex }) {
      if (row.isEnable === 1) {
        return ''
      }
      return 'disable-row'
    }
  }
}
</script>

<style scoped>
  #hotel-list-table {
    width: 100%;
    border: 1px solid #dddddd;
    border-radius: 5px;
    box-shadow: 0px 3px 5px 1px #eeeeee;
  }
  .el-table th {
    background-color: #eeeeee;
  }
  .el-form > div {
    text-align: left;
  }
</style>
